// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2IAIs","calendarButtons":"ClockData_calendarButtons__harTS"};